// src/notifications/notificationTypes.js
// Types et modèles de notifications - NE PAS MODIFIER

/**
 * Types de notifications
 */
export const NOTIFICATION_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
  };
  
  /**
   * Durées par défaut des notifications (en ms)
   */
  export const NOTIFICATION_DURATIONS = {
    success: 5000,
    error: 8000,
    warning: 6000,
    info: 5000,
  };
  
  /**
   * Couleurs pour chaque type
   */
  export const NOTIFICATION_COLORS = {
    success: '#48BB78',
    error: '#F56565',
    warning: '#ED8936',
    info: '#4299E1',
  };
  
  /**
   * Icônes pour chaque type
   */
  export const NOTIFICATION_ICONS = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
  };
  
  /**
   * Messages de notification prédéfinis
   */
  export const NOTIFICATION_MESSAGES = {
    // Succès
    listingCreated: {
      type: NOTIFICATION_TYPES.SUCCESS,
      title: 'Succès',
      message: 'Annonce créée avec succès',
    },
    listingUpdated: {
      type: NOTIFICATION_TYPES.SUCCESS,
      title: 'Succès',
      message: 'Annonce mise à jour avec succès',
    },
    listingDeleted: {
      type: NOTIFICATION_TYPES.SUCCESS,
      title: 'Succès',
      message: 'Annonce supprimée avec succès',
    },
    listingApproved: {
      type: NOTIFICATION_TYPES.SUCCESS,
      title: 'Succès',
      message: 'Annonce approuvée et publiée',
    },
    reservationCreated: {
      type: NOTIFICATION_TYPES.SUCCESS,
      title: 'Succès',
      message: 'Réservation envoyée avec succès',
    },
    reservationConfirmed: {
      type: NOTIFICATION_TYPES.SUCCESS,
      title: 'Succès',
      message: 'Réservation confirmée',
    },
    adminCreated: {
      type: NOTIFICATION_TYPES.SUCCESS,
      title: 'Succès',
      message: 'Administrateur créé avec succès',
    },
    adminDeleted: {
      type: NOTIFICATION_TYPES.SUCCESS,
      title: 'Succès',
      message: 'Administrateur supprimé avec succès',
    },
    addedToFavorites: {
      type: NOTIFICATION_TYPES.SUCCESS,
      title: 'Succès',
      message: 'Ajouté aux favoris',
    },
    removedFromFavorites: {
      type: NOTIFICATION_TYPES.SUCCESS,
      title: 'Succès',
      message: 'Retiré des favoris',
    },
    dataSaved: {
      type: NOTIFICATION_TYPES.SUCCESS,
      title: 'Succès',
      message: 'Données sauvegardées',
    },
  
    // Erreurs
    listingCreationFailed: {
      type: NOTIFICATION_TYPES.ERROR,
      title: 'Erreur',
      message: 'Erreur lors de la création de l\'annonce',
    },
    listingUpdateFailed: {
      type: NOTIFICATION_TYPES.ERROR,
      title: 'Erreur',
      message: 'Erreur lors de la mise à jour de l\'annonce',
    },
    listingDeletionFailed: {
      type: NOTIFICATION_TYPES.ERROR,
      title: 'Erreur',
      message: 'Erreur lors de la suppression de l\'annonce',
    },
    reservationFailed: {
      type: NOTIFICATION_TYPES.ERROR,
      title: 'Erreur',
      message: 'Erreur lors de l\'envoi de la réservation',
    },
    authenticationFailed: {
      type: NOTIFICATION_TYPES.ERROR,
      title: 'Erreur',
      message: 'Authentification échouée. Vérifiez vos identifiants.',
    },
    networkError: {
      type: NOTIFICATION_TYPES.ERROR,
      title: 'Erreur réseau',
      message: 'Erreur de connexion. Vérifiez votre internet.',
    },
    serverError: {
      type: NOTIFICATION_TYPES.ERROR,
      title: 'Erreur serveur',
      message: 'Erreur serveur. Réessayez plus tard.',
    },
    sessionExpired: {
      type: NOTIFICATION_TYPES.ERROR,
      title: 'Session expirée',
      message: 'Votre session a expiré. Veuillez vous reconnecter.',
    },
    permissionDenied: {
      type: NOTIFICATION_TYPES.ERROR,
      title: 'Accès refusé',
      message: 'Vous n\'avez pas les permissions pour effectuer cette action.',
    },
    validationError: {
      type: NOTIFICATION_TYPES.ERROR,
      title: 'Erreur de validation',
      message: 'Vérifiez les données saisies.',
    },
  
    // Avertissements
    unsavedChanges: {
      type: NOTIFICATION_TYPES.WARNING,
      title: 'Attention',
      message: 'Vous avez des modifications non sauvegardées',
    },
    deletionWarning: {
      type: NOTIFICATION_TYPES.WARNING,
      title: 'Attention',
      message: 'Cette action est irréversible',
    },
    noInternet: {
      type: NOTIFICATION_TYPES.WARNING,
      title: 'Pas de connexion',
      message: 'Vous êtes hors ligne. Certaines fonctionnalités sont limitées.',
    },
    slowConnection: {
      type: NOTIFICATION_TYPES.WARNING,
      title: 'Connexion lente',
      message: 'Votre connexion est lente. L\'app peut être plus lente.',
    },
    largeFile: {
      type: NOTIFICATION_TYPES.WARNING,
      title: 'Attention',
      message: 'Le fichier est volumineux. L\'upload peut prendre du temps.',
    },
  
    // Infos
    loadingData: {
      type: NOTIFICATION_TYPES.INFO,
      title: 'Chargement',
      message: 'Chargement des données...',
    },
    processingRequest: {
      type: NOTIFICATION_TYPES.INFO,
      title: 'Traitement',
      message: 'Traitement de votre demande...',
    },
    syncingData: {
      type: NOTIFICATION_TYPES.INFO,
      title: 'Synchronisation',
      message: 'Synchronisation des données...',
    },
    uploadingImage: {
      type: NOTIFICATION_TYPES.INFO,
      title: 'Envoi',
      message: 'Envoi de l\'image...',
    },
    filteringResults: {
      type: NOTIFICATION_TYPES.INFO,
      title: 'Filtrage',
      message: 'Filtrage des résultats...',
    },
  };
  
  /**
   * Configuration des actions par notification
   */
  export const NOTIFICATION_ACTIONS = {
    sessionExpired: {
      label: 'Se reconnecter',
      callback: () => {
        window.location.href = '/login';
      },
    },
    noInternet: {
      label: 'Réessayer',
      callback: () => {
        window.location.reload();
      },
    },
    undoDelete: {
      label: 'Annuler',
      callback: null, // À définir par le composant
    },
  };
  
  /**
   * Enqueue de notifications (pour éviter les chevauchements)
   */
  export const NOTIFICATION_QUEUE = {
    maxVisible: 3,
    position: 'top-right', // 'top-left', 'top-right', 'bottom-left', 'bottom-right'
  };
  
  /**
   * Classe pour gérer les notifications
   */
  export class NotificationManager {
    constructor() {
      this.notifications = [];
      this.listeners = [];
    }
  
    /**
     * Ajouter une notification
     */
    add(notification) {
      const id = Date.now();
      const fullNotification = {
        id,
        ...notification,
        createdAt: new Date(),
      };
  
      this.notifications.push(fullNotification);
      this.notifyListeners();
  
      // Auto-remove après la durée
      if (notification.duration !== 0) {
        const duration = notification.duration || NOTIFICATION_DURATIONS[notification.type] || 5000;
        setTimeout(() => {
          this.remove(id);
        }, duration);
      }
  
      return id;
    }
  
    /**
     * Retirer une notification
     */
    remove(id) {
      this.notifications = this.notifications.filter((n) => n.id !== id);
      this.notifyListeners();
    }
  
    /**
     * Effacer toutes les notifications
     */
    clear() {
      this.notifications = [];
      this.notifyListeners();
    }
  
    /**
     * S'abonner aux changements
     */
    subscribe(listener) {
      this.listeners.push(listener);
      return () => {
        this.listeners = this.listeners.filter((l) => l !== listener);
      };
    }
  
    /**
     * Notifier les listeners
     */
    notifyListeners() {
      this.listeners.forEach((listener) => {
        listener(this.notifications);
      });
    }
  
    /**
     * Obtenir les notifications actuelles
     */
    getAll() {
      return this.notifications;
    }
  
    /**
     * Obtenir les X dernières notifications visibles
     */
    getVisible(limit = NOTIFICATION_QUEUE.maxVisible) {
      return this.notifications.slice(-limit);
    }
  
    /**
     * Ajouter une notification de succès
     */
    success(title, message, duration) {
      return this.add({
        type: NOTIFICATION_TYPES.SUCCESS,
        title,
        message,
        duration: duration || NOTIFICATION_DURATIONS.success,
      });
    }
  
    /**
     * Ajouter une notification d'erreur
     */
    error(title, message, duration) {
      return this.add({
        type: NOTIFICATION_TYPES.ERROR,
        title,
        message,
        duration: duration || NOTIFICATION_DURATIONS.error,
      });
    }
  
    /**
     * Ajouter une notification d'avertissement
     */
    warning(title, message, duration) {
      return this.add({
        type: NOTIFICATION_TYPES.WARNING,
        title,
        message,
        duration: duration || NOTIFICATION_DURATIONS.warning,
      });
    }
  
    /**
     * Ajouter une notification d'info
     */
    info(title, message, duration) {
      return this.add({
        type: NOTIFICATION_TYPES.INFO,
        title,
        message,
        duration: duration || NOTIFICATION_DURATIONS.info,
      });
    }
  
    /**
     * Ajouter une notification prédéfinie
     */
    addPredefined(key, customMessage) {
      const template = NOTIFICATION_MESSAGES[key];
      if (!template) {
        console.warn(`Notification template not found: ${key}`);
        return;
      }
  
      return this.add({
        ...template,
        message: customMessage || template.message,
      });
    }
  }
  
  /**
   * Instance globale du gestionnaire de notifications
   */
  export const notificationManager = new NotificationManager();